import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import { SetValueETargetValue } from "../../Services/service";

const CustomTextField = TextField;

export const Cus_Autocomplete = ({
  id,
  options,
  value,
  setValue,
  sxText,
  sxAuto,
  placeholder,
  className,
  option
}) => {
  return (
    <Autocomplete
      value={value}
      disablePortal
      fullWidth={true}
      id={id}
      options={options}
      getOptionLabel={option}
      className={className}
      onChange={(event, newValue) => {
        SetValueETargetValue(newValue, setValue);
      }}
      sx={{
        "& + .MuiAutocomplete-popper .MuiAutocomplete-option": {
          fontSize: "13px",
        },
        "& .MuiInputBase-root": {
          fontSize: "14px",
          "@media (max-width: 2200px) and (min-width: 2000px)": {
            fontSize: "22px",
          },
          "@media (max-width: 2000px) and (min-width: 1800px)": {
            fontSize: "17px",
          },
          "@media (max-width: 1800px) and (min-width: 1400px)": {
            fontSize: "15px",
          },
          "@media (max-width: 960px) and (min-width: 769px)": {
            fontSize: "12px",
          },
          "@media (max-width: 768px) and (min-width: 687px)": {
            fontSize: "20px",
          },
          "@media (max-width: 687px)": {
            fontSize: "12px",
          },
        },

        "& .MuiSvgIcon-root":{
          "@media (max-width: 768px) and (min-width: 687px)": {
            fontSize: "3.5rem",
          },
          "@media (max-width: 687px)": {
            fontSize: "2rem",
          },
        },
        "& .MuiAutocomplete-clearIndicator":{
          "@media (max-width: 768px) and (min-width: 687px)": {
            fontSize: "2.5rem",
          },
          "@media (max-width: 687px)": {
            fontSize: "1.5rem",
          },
        },

        "& + .MuiAutocomplete-popper .MuiAutocomplete-option": {
          fontSize: "14px",
          "@media (max-width: 2200px) and (min-width: 2000px)": {
            fontSize: "22px",
          },
          "@media (max-width: 2000px) and (min-width: 1800px)": {
            fontSize: "17px",
          },
          "@media (max-width: 1800px) and (min-width: 1400px)": {
            fontSize: "15px",
          },
          "@media (max-width: 960px) and (min-width: 769px)": {
            fontSize: "12px",
          },
          "@media (max-width: 768px) and (min-width: 687px)": {
            fontSize: "20px",
          },
          "@media (max-width: 687px)": {
            fontSize: "12px",
            height: "20px"
          },
        },

        "&.MuiAutocomplete-root .MuiOutlinedInput-root": {
          padding: "5px 9px",
          margin: "5px 0px",
          backgroundColor: "white",
        },
        "&.MuiFormLabel-root .MuiInputLabel-root": {
          top: "-4px",
          "@media (max-width: 960px) and (min-width: 688px)": {
            top: "-2px",
          },
          "@media (max-width: 687px)": {
            top: "0px",
          },
        },
        ...sxAuto,
      }}
      renderInput={(params) => (
        <CustomTextField
          placeholder={placeholder}
          {...params}
          sx={{
            fontSize: "25px",
            "& label.Mui-focused": {
              color: "#c4960c",
            },
            "& .MuiInput-underline:after": {
              borderBottomColor: "#c4960c",
            },
            "& .MuiFilledInput-underline:after": {
              borderBottomColor: "#c4960c",
            },
            "& .MuiOutlinedInput-root": {
              "&.Mui-focused fieldset": {
                borderColor: "#c4960c",
              },
              "& .MuiAutocomplete-input": {
                fontSize: "13px",
                "@media (max-width: 2200px) and (min-width: 2000px)": {
                  fontSize: "22px",
                },
                "@media (max-width: 2000px) and (min-width: 1800px)": {
                  fontSize: "17px",
                },
                "@media (max-width: 1800px) and (min-width: 1400px)": {
                  fontSize: "15px",
                },
                "@media (max-width: 960px) and (min-width: 769px)": {
                  fontSize: "11px",
                },
                "@media (max-width: 768px) and (min-width: 687px)": {
                  fontSize: "20px",
                  height: "23px",
                },
                "@media (max-width: 687px)": {
                  fontSize: "12px",
                  height: "12px"
                },
              },
              "& + .MuiAutocomplete-popper .MuiAutocomplete-option": {
                fontSize: "13px",
                "@media (max-width: 2200px) and (min-width: 2000px)": {
                  fontSize: "22px",
                },
                "@media (max-width: 2000px) and (min-width: 1800px)": {
                  fontSize: "17px",
                },
                "@media (max-width: 1800px) and (min-width: 1400px)": {
                  fontSize: "15px",
                },
                "@media (max-width: 960px) and (min-width: 769px)": {
                  fontSize: "11px",
                },
                "@media (max-width: 768px) and (min-width: 687px)": {
                  fontSize: "20px",
                  height: "23px",
                },
                "@media (max-width: 687px)": {
                  fontSize: "12px",
                  height: "8px"
                },
              },
            },
            "& .MuiInputLabel-root": {
              fontSize: "14px",
              "@media (max-width: 2200px) and (min-width: 2000px)": {
                fontSize: "22px",
                height: "30px"
              },
              "@media (max-width: 2000px) and (min-width: 1800px)": {
                fontSize: "17px",
              },
              "@media (max-width: 1800px) and (min-width: 1400px)": {
                fontSize: "15px",
              },
              "@media (max-width: 960px) and (min-width: 769px)": {
                fontSize: "12px",
              },
              "@media (max-width: 768px) and (min-width: 687px)": {
                fontSize: "20px",
                height: "23px",
              },
              "@media (max-width: 687px)": {
                fontSize: "12px",
                height: "8px"
              },
            },
            ...sxText,
          }}
        />
      )}
      size="medium"
    />
  );
};
